module.exports = __webpack_public_path__ + "img/69.8525b5a7.png";